import ErroneousReadings from 'components/molecules/admin-panel/forms/erroneous-readings';

import type { FC } from 'react';

interface AdminErroneousActivityProps {
  patientGuid: string;
}

const AdminErroneousActivity: FC<AdminErroneousActivityProps> = ({
  patientGuid,
}) => {
  return <ErroneousReadings patientGuid={patientGuid} />;
};
export default AdminErroneousActivity;
